export class SquidexDate extends Date {
  constructor(date: number | string | Date) {
    super(date);
  }

  format(): string {
    if (typeof this === "object") {
      const validateDate = new Date(1970, 0, 0, 19, 0, 0);

      if (this.toISOString() === validateDate.toISOString()) {
        return '';
      }
    }

    return this.getFullYear() +
      '-' + this.pad(this.getMonth() + 1) +
      '-' + this.pad(this.getDate()) +
      'T' + this.pad(this.getHours()) +
      ':' + this.pad(this.getMinutes()) +
      ':' + this.pad(this.getSeconds()) +
      'Z';
  }

  formatUtc(): string {
    if (typeof this === "object") {
      const validateDate = new Date(1970, 0, 0, 19, 0, 0);

      if (this.toISOString() === validateDate.toISOString()) {
        return '';
      }
    }
    return this.toISOString().slice(0, -5) + 'Z';
  }

  formatWithoutTime(): string {
    if (typeof this === "object") {
      const validateDate = new Date(1970, 0, 0, 19, 0, 0);

      if (this.toISOString() === validateDate.toISOString()) {
        return '';
      }
    }

    return this.getUTCFullYear() +
      '-' + this.pad(this.getUTCMonth() + 1) +
      '-' + this.pad(this.getUTCDate()) +
      'T12' +
      ':00' +
      ':00' +
      'Z';
  }

  private pad(number) {
    if (number < 10) {
      return '0' + number;
    }
    return number;
  }
}


